import React, { ChangeEvent } from 'react';

type CheckboxProps = {
  id?: string;
  name?: string;
  value?: string;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  style?: React.CSSProperties;
};

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name,
  value,
  checked,
  onChange,
  className = '',
  style = {},
}) => {
  const defaultColor = '#414149';
  const checkedColor = style.color || defaultColor;
  const width = style.width || '20px';
  const height = style.height || '20px';

  return (
    <div style={{ position: 'relative', width, height }}>
      <input
        type='checkbox'
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className={`cursor-pointer ${className}`}
        style={{
          width: '100%',
          height: '100%',
          margin: 0,
          appearance: 'none',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          border: checked ? 'none' : `2px solid ${defaultColor}`,
          borderRadius: '2px',
          backgroundColor: checked ? checkedColor : 'transparent',
          cursor: 'pointer',
          position: 'relative',
          ...style,
        }}
      />
      {checked && (
        <svg
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
            width: '18px',
            height: '18px',
          }}
          viewBox='0 0 12 12'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10 3L4.5 8.5L2 6'
            stroke='white'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      )}
    </div>
  );
};

export default Checkbox;
